<template>
    <div class="position-relative">
        <div
            class="swiper swiper-video-testimonial"
            data-aos="fade-up"
            ref="swiperContainer"
        >
            <div class="swiper-wrapper">
                <div
                    class="swiper-slide"
                    v-for="entry in entries"
                    :key="entry.image"
                    :entry="entry"
                    :section="section"
                >
                    <video
                        ref="videos"
                        controls
                        class="portrait-video"
                        :poster="entry.image"
                        preload="none"
                        loading="lazy"
                    >
                        <source :src="entry.videoWeb" type="video/webm" />
                        <source :src="entry.video" type="video/mp4" />
                        {{ entry.description }}
                    </video>
                </div>
            </div>
        </div>
        <SwiperControlsTest />
    </div>
</template>

<script>
import { ref, onMounted, nextTick } from "vue";
import SwiperControlsTest from "../partials/swiper-test-controls-partials.vue";
import Swiper from "swiper/bundle";
import "swiper/css/bundle";

export default {
    components: {
        SwiperControlsTest,
    },
    setup() {
        return {}
  },
  props: ['entries', 'section'],
};
</script>